
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPaymentDashboardData } from '../../../../redux/reducers/paymentDashboardSlice';
function SummaryCards() {
  const dispatch = useDispatch();
  const { totalSale, totalPurchase, unpaidCount, unpaidTotal, loading } = useSelector(
    (state) => state.paymentDashboard
  );
const formatNumber = (num) => {
    const value = Number(num);
    return value.toFixed(2); 
  };
  useEffect(() => {
    dispatch(fetchPaymentDashboardData());
  }, [dispatch]);

  const cards = [
    { title: 'Total Sales', value: formatNumber( totalSale)},
 { title: 'Total Purchases', value: formatNumber(totalPurchase) },
    { title: 'Unpaid Invoices', value: formatNumber(unpaidCount) },
    { title: 'Unpaid Total', value: formatNumber(unpaidTotal) },  ];

  if (loading && !totalSale && !unpaidCount) {
    return <p>Loading...</p>;
  }

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      {cards.map((card, i) => (
        <div
          key={i}
          style={{
            padding: '1px 20px 20px 20px',
            background: '#e9f2ff',
            borderRadius: '16px',
            flex: 1,
          }}
        >
          <h4>{card.title}</h4>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ margin: 0 }}>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;